<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Kategorie erstellen') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.post(route('admin.categories.store'))">
                <form-fields :form="form" :category-options="categoryTree" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'parentId',
            'categoryTree',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    parent_id: this.parentId,
                    name: null,
                    slug: null,
                    image_id: null,
                    default_product_image_id: null,
                    sort_order: null,
                    enabled: null,
                    mdr_classified_products: null,
                    hazardous_material_products: null,
                    keywords: null,
                    meta_title: null,
                    meta_description: null,
                    description: null,
                    notes: null,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>